import {
  useGetComplianceReport,
  useSetComplianceReport,
} from "@/requests/hooks/collect";
import ComplianceReportLoading from "@/routes/Common/ComplianceReport/ComplianceReportLoading";
import ComplianceReportView from "@/routes/Common/ComplianceReport/view";
import { useParams } from "react-router-dom";

const ComplianceReportController = () => {
  const { id } = useParams();

  const complianceReportGet = useGetComplianceReport(id);
  const complianceReportSet = useSetComplianceReport();

  const {
    isFetching: isFetchingGetComplianceReport,
    isRefetching: isRefetchingGetComplianceReport,
  } = complianceReportGet;

  if (isFetchingGetComplianceReport && !isRefetchingGetComplianceReport)
    return <ComplianceReportLoading />;

  return (
    <ComplianceReportView
      complianceReportGet={complianceReportGet}
      complianceReportSet={complianceReportSet}
    />
  );
};

export default ComplianceReportController;
